// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 231 ? "5dde9fb5" : chunkId) + "." + {"60":"c3c16d0b9de75815","182":"30616906f849b3bf","231":"b4acf3ee595eaeee","256":"ee6e90f6d34d5dbe","494":"3756041f075e4f26","763":"9ced2f1611e0217c"}[chunkId] + ".js";
};